import { Link, useLocation } from 'react-router-dom'
import { cn } from '~/shadcn/lib/utils'

type Props = {
  to: string
  target?: string
  isActivePathCallback?: (pathname: string) => boolean
  colorScheme: 'light' | 'dark'
  children: React.ReactNode
}

const baseStyles = [
  'flex px-5 h-full self-stretch items-center',
  'outline-offset-4 outline-transparent',
  'relative',
]

const underlineStyles = [
  'after:content-[""] after:absolute after:bottom-0 after:left-0',
  'after:w-full after:h-1 after:z-[1]',
  'after:bg-accent after:origin-center',
  'after:transition-all after:duration-300',
]

function TopNavLink({
  to,
  target,
  isActivePathCallback,
  colorScheme,
  children,
}: Props) {
  const { pathname } = useLocation()

  const isActive =
    pathname === to || (isActivePathCallback?.(pathname) ?? false)

  return (
    <Link
      to={to}
      target={target}
      className={cn(
        baseStyles,
        underlineStyles,
        colorScheme === 'dark' ? 'text-primary-foreground' : 'text-primary',
        isActive
          ? 'text-accent outline-accent after:opacity-100 after:transform-[scaleX(1)]'
          : 'after:opacity-0 after:transform-[scaleX(0)] hover:after:opacity-100 hover:after:transform-[scaleX(1)]'
      )}>
      {children}
    </Link>
  )
}

export { TopNavLink }
